module.exports = "<p>\n  howwork works!\n</p>\n"